import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg, gbp } from "@/lib/api";

const EMPTY = { organisation: "", contact_name: "", email: "", phone: "" };

export const SubscribeDialog = ({ plan, sectorName, onClose }) => {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout/subscription", {
        ...form,
        phone: form.phone || null,
        lookup_key: plan.lookup_key,
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(errMsg(err));
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!plan} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#FAF8F5] sm:max-w-lg" data-lenis-prevent data-testid="subscribe-dialog">
        {plan && (
          <>
            <DialogHeader>
              <p className="eyebrow text-[#9a7614]">{sectorName}</p>
              <DialogTitle className="font-display text-3xl">Subscribe to {plan.name}</DialogTitle>
              <DialogDescription>
                {gbp(plan.amount)} per month. You'll complete payment securely with Stripe.
              </DialogDescription>
            </DialogHeader>
            <form onSubmit={submit} className="grid gap-4" data-testid="subscribe-form">
              <div>
                <label className="label">Organisation</label>
                <input required className="field" value={form.organisation} onChange={set("organisation")} data-testid="subscribe-organisation-input" />
              </div>
              <div className="grid gap-4 sm:grid-cols-2">
                <div>
                  <label className="label">Your name</label>
                  <input required className="field" value={form.contact_name} onChange={set("contact_name")} data-testid="subscribe-name-input" />
                </div>
                <div>
                  <label className="label">Phone</label>
                  <input className="field" value={form.phone} onChange={set("phone")} data-testid="subscribe-phone-input" />
                </div>
              </div>
              <div>
                <label className="label">Email</label>
                <input required type="email" className="field" value={form.email} onChange={set("email")} data-testid="subscribe-email-input" />
              </div>
              <button disabled={busy} className="btn-ink justify-center" data-testid="subscribe-checkout-button">
                {busy ? "Opening secure checkout…" : "Continue to payment"}
              </button>
            </form>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
